module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hk6PG"))).then(() => parcelRequire('ljYL6'));